module.exports = __webpack_public_path__ + "static/media/meditation.a78f8501.jpg";